<template>
  <div :class="{ 'bpa-check': true, 'checked': checked }" @click="triggerClicked">
    <div>
      <input type="checkbox" class="checkbox-round" :value="value ? value : data.id" ref="checkbox" />
    </div>
    <label>{{ label ? label : data.name }}</label>
  </div>
</template>
  
<script>
export default {
  props: {
    data: Object,
    is_active: Object,
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
  },
  data () {
    return {
      checked: false
    }
  },
  methods: {
    triggerClicked ( e ) {
      this.$refs.checkbox.click()
      const obj = this.data
      obj.checked = this.$refs.checkbox.checked
      obj.term_id = this.value ? this.value : obj.term_id
      this.$emit( 'onTriggeredClicked', obj )
    }
  },
  mounted () {
  },
  computed: {
    model: {
      get () { return `${ this.type }` },
      set ( newValue ) { this.$emit( 'input', newValue ) }
    }
  },
  watch: {
    is_active: function ( selected ) {
      if ( selected.find( e => { return e.term_id === this.data.term_id && e.taxonomy == this.data.taxonomy } ) ) {
        this.$refs.checkbox.checked = true
        this.checked = true
      } else {
        this.$refs.checkbox.checked = false
        this.checked = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.bpa-check {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  margin-left: -10px;
  min-height: 41px;
  transition: none;
  cursor: pointer;

  &:hover {
    background-color: #EBEBEB;
    border-radius: 21px;

    @include xl {
      background-color: initial;
      border-radius: unset;
    }
  }

  &.checked {
    background-color: #EBEBEB;
    border-radius: 21px;
  }

  &:checked .checkbox-round {
    background-color: #0B3148;
    border: 3px solid #ffffff;
  }

  &:hover .checkbox-round {
    border: 3px solid #ffffff;

    @include xl {
      border: unset;
    }
  }

  .checkbox-round {
    width: 21px;
    height: 21px;
    margin-left: 0;
    padding: 0;
    background-color: #EBEBEB;
    border: 3px solid #EBEBEB;
    border-radius: 50%;
    vertical-align: middle;
    appearance: none;
    outline: none;
    pointer-events: none;

    &:checked {
      background-color: #0B3148;
      border: 3px solid #ffffff;
    }
  }

  label {
    font-size: 16px;
  }
}
</style>